import { Text } from "@ttc3k/trekker";
import { IAlphabetic, useAlphabet } from "shared/hooks";
import { Box, BoxProps, Flex } from "styled-system/jsx";

type AlphabetJumperProps = BoxProps & {
  alphabetGroups: IAlphabetic[];
  jumpBase: string;
  onLetterClick?: (letter: string) => void;
};

export const AlphabetJumper = ({
  alphabetGroups,
  jumpBase,
  onLetterClick,
  ...rest
}: AlphabetJumperProps) => {
  const { alphabet } = useAlphabet();

  const handleLetterClick = (letter: string) => {
    // If we aren't using a virtualizer, scroll to the letter
    document.getElementById(`${jumpBase}${letter}`)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    // If we are using a virtualizer, output the letter so the virualizer can deal with it
    onLetterClick?.(letter);
  };

  return (
    <Box position="sticky" alignSelf="flex-start" top="0" {...rest}>
      <Flex flexDir="column" alignItems="center" gap="25">
        {alphabet.map((letter, i) => (
          <Text
            key={letter}
            visual="smallTag"
            cursor={
              alphabetGroups[i] && alphabetGroups[i].operators.length > 0
                ? "pointer"
                : "default"
            }
            color={
              alphabetGroups[i] && alphabetGroups[i].operators.length > 0
                ? "text.dart"
                : "text.disabled"
            }
            onClick={() =>
              alphabetGroups[i] && alphabetGroups[i].operators.length > 0
                ? handleLetterClick(letter.toUpperCase())
                : null
            }
          >
            {letter.toUpperCase()}
          </Text>
        ))}
      </Flex>
    </Box>
  );
};
